import { watchActivateContact } from './activateContact';
import { watchAddContact } from './addContact';
import { watchDeactivateContact } from './deactivateContact';
import { watchFetchContacts } from './fetchContacts';
import { watchFetchContactsById } from './fetchContactsById';
import { watchUpdateContact } from './updateContact';

export const contactSagas = [
  watchActivateContact(),
  watchAddContact(),
  watchDeactivateContact(),
  watchFetchContacts(),
  watchFetchContactsById(),
  watchUpdateContact()
];
